<div class="error-container">
  <div class="lds-ripple">
    <div></div>
    <div></div>
  </div>
  <br />
  <h1 class="error-text">{{ data.text }}</h1>
</div>
